import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import { VenueEdit, VenueReadOnly } from './VenueForm';

export default function VenuePage({}: any) {
  return (
    <GenericCrudPage
      key='company-page'
      singularName='company'
      pageTitle='Venues'
      resource='venue'
      allowAdd={false}
      allowEdit={false}
      allowDelete={false}
      ReadOnlyComponent={VenueReadOnly}
      EditFormComponent={VenueEdit}
      tableColumns={[
        {
          field: 'name',
          headerName: 'Name',
          width: 400,
        },
      ]}
      newPayload={{
        uuid: '',
        name: '',
        address: '',
        location: {
          type: 'Point',
          coordinates: [0, 0],
        },
      }}
      validateFn={(data: any) => {
        return [true, []];
      }}
    />
  );
}
